import { useCallback, useRef } from "react";

type UseAutoSaveOptions = {
  /** 保存時に呼び出されるコールバック */
  onSave: (changes: Record<string, unknown>) => void;
  /** debounce 遅延時間（ミリ秒） */
  delay?: number;
};

/** フィールド変更をバッチ化して debounce 後に一括送信するフック */
export const useAutoSave = ({ onSave, delay = 300 }: UseAutoSaveOptions) => {
  const pendingChanges = useRef<Record<string, unknown>>({});
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const onSaveRef = useRef(onSave);
  onSaveRef.current = onSave;

  const trackChange = useCallback(
    (changes: Record<string, unknown>) => {
      pendingChanges.current = { ...pendingChanges.current, ...changes };

      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }

      timerRef.current = setTimeout(() => {
        const batch = { ...pendingChanges.current };
        pendingChanges.current = {};
        timerRef.current = null;
        onSaveRef.current(batch);
      }, delay);
    },
    [delay],
  );

  return { trackChange };
};
